// This file is auto-generated by @hey-api/openapi-ts

import type {
  Options as ClientOptions,
  TDataShape,
  Client,
} from "@hey-api/client-fetch";
import type {
  GetApiKeyData,
  GetApiKeyResponse,
  GetCoinData,
  GetCoinResponse,
  GetCoinCommentsData,
  GetCoinCommentsResponse,
  GetCoinHoldersData,
  GetCoinHoldersResponse,
  GetCoinPriceHistoryData,
  GetCoinPriceHistoryResponse,
  GetCoinSwapsData,
  GetCoinSwapsResponse,
  GetCoinsData,
  GetCoinsResponse,
  GetCoinsListData,
  GetCoinsListResponse,
  GetContentCoinPoolConfigData,
  GetContentCoinPoolConfigResponse,
  SetCreateUploadJwtData,
  SetCreateUploadJwtResponse,
  GetCreatorCoinPoolConfigData,
  GetCreatorCoinPoolConfigResponse,
  GetCreatorLivestreamCommentsData,
  GetCreatorLivestreamCommentsResponse,
  GetExploreData,
  GetExploreResponse,
  GetFeaturedCreatorsData,
  GetFeaturedCreatorsResponse,
  GetLatestLiveStreamsData,
  GetLatestLiveStreamsResponse,
  GetProfileData,
  GetProfileResponse,
  GetProfileBalancesData,
  GetProfileBalancesResponse,
  GetProfileBySocialHandleData,
  GetProfileBySocialHandleResponse,
  GetProfileCoinsData,
  GetProfileCoinsResponse,
  GetProfileSocialData,
  GetProfileSocialResponse,
  GetTokenInfoData,
  GetTokenInfoResponse,
  GetTopLiveStreamsData,
  GetTopLiveStreamsResponse,
  GetTraderLeaderboardData,
  GetTraderLeaderboardResponse,
  GetTrendCoinData,
  GetTrendCoinResponse,
  GetTrendsByNameData,
  GetTrendsByNameResponse,
  GetWalletTradeActivityData,
  GetWalletTradeActivityResponse,
  PostQuoteData,
  PostQuoteResponse,
  PostQuoteError,
  PostCreateContentData,
  PostCreateContentResponse,
  PostCreateContentError,
} from "./types.gen";
import { client as _heyApiClient } from "./client.gen";

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
> = ClientOptions<TData, ThrowOnError> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

/**
 * zoraSDK_apiKey query
 */
export const getApiKey = <ThrowOnError extends boolean = false>(
  options: Options<GetApiKeyData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetApiKeyResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: "api-key",
        type: "apiKey",
      },
    ],
    url: "/apiKey",
    ...options,
  });
};

/**
 * zoraSDK_coin query
 */
export const getCoin = <ThrowOnError extends boolean = false>(
  options: Options<GetCoinData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetCoinResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: "api-key",
        type: "apiKey",
      },
    ],
    url: "/coin",
    ...options,
  });
};

/**
 * zoraSDK_coinComments query
 */
export const getCoinComments = <ThrowOnError extends boolean = false>(
  options: Options<GetCoinCommentsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetCoinCommentsResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: "api-key",
        type: "apiKey",
      },
    ],
    url: "/coinComments",
    ...options,
  });
};

/**
 * zoraSDK_coinHolders query
 */
export const getCoinHolders = <ThrowOnError extends boolean = false>(
  options: Options<GetCoinHoldersData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetCoinHoldersResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: "api-key",
        type: "apiKey",
      },
    ],
    url: "/coinHolders",
    ...options,
  });
};

/**
 * zoraSDK_coinPriceHistory query
 */
export const getCoinPriceHistory = <ThrowOnError extends boolean = false>(
  options: Options<GetCoinPriceHistoryData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetCoinPriceHistoryResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: "api-key",
        type: "apiKey",
      },
    ],
    url: "/coinPriceHistory",
    ...options,
  });
};

/**
 * zoraSDK_coinSwaps query
 */
export const getCoinSwaps = <ThrowOnError extends boolean = false>(
  options: Options<GetCoinSwapsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetCoinSwapsResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: "api-key",
        type: "apiKey",
      },
    ],
    url: "/coinSwaps",
    ...options,
  });
};

/**
 * zoraSDK_coins query
 */
export const getCoins = <ThrowOnError extends boolean = false>(
  options: Options<GetCoinsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetCoinsResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: "api-key",
        type: "apiKey",
      },
    ],
    url: "/coins",
    ...options,
  });
};

/**
 * zoraSDK_coinsList query
 */
export const getCoinsList = <ThrowOnError extends boolean = false>(
  options?: Options<GetCoinsListData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    GetCoinsListResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: "api-key",
        type: "apiKey",
      },
    ],
    url: "/coinsList",
    ...options,
  });
};

/**
 * zoraSDK_contentCoinPoolConfig query
 */
export const getContentCoinPoolConfig = <ThrowOnError extends boolean = false>(
  options: Options<GetContentCoinPoolConfigData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetContentCoinPoolConfigResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: "api-key",
        type: "apiKey",
      },
    ],
    url: "/contentCoinPoolConfig",
    ...options,
  });
};

/**
 * zoraSDK_createUploadJWT mutation
 */
export const setCreateUploadJwt = <ThrowOnError extends boolean = false>(
  options?: Options<SetCreateUploadJwtData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).post<
    SetCreateUploadJwtResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: "api-key",
        type: "apiKey",
      },
    ],
    url: "/createUploadJWT",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * zoraSDK_creatorCoinPoolConfig query
 */
export const getCreatorCoinPoolConfig = <ThrowOnError extends boolean = false>(
  options?: Options<GetCreatorCoinPoolConfigData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    GetCreatorCoinPoolConfigResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: "api-key",
        type: "apiKey",
      },
    ],
    url: "/creatorCoinPoolConfig",
    ...options,
  });
};

/**
 * zoraSDK_creatorLivestreamComments query
 */
export const getCreatorLivestreamComments = <
  ThrowOnError extends boolean = false,
>(
  options: Options<GetCreatorLivestreamCommentsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetCreatorLivestreamCommentsResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: "api-key",
        type: "apiKey",
      },
    ],
    url: "/creatorLivestreamComments",
    ...options,
  });
};

/**
 * zoraSDK_explore query
 */
export const getExplore = <ThrowOnError extends boolean = false>(
  options: Options<GetExploreData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetExploreResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: "api-key",
        type: "apiKey",
      },
    ],
    url: "/explore",
    ...options,
  });
};

/**
 * zoraSDK_featuredCreators query
 */
export const getFeaturedCreators = <ThrowOnError extends boolean = false>(
  options?: Options<GetFeaturedCreatorsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    GetFeaturedCreatorsResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: "api-key",
        type: "apiKey",
      },
    ],
    url: "/featuredCreators",
    ...options,
  });
};

/**
 * zoraSDK_latestLiveStreams query
 */
export const getLatestLiveStreams = <ThrowOnError extends boolean = false>(
  options?: Options<GetLatestLiveStreamsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    GetLatestLiveStreamsResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: "api-key",
        type: "apiKey",
      },
    ],
    url: "/latestLiveStreams",
    ...options,
  });
};

/**
 * zoraSDK_profile query
 */
export const getProfile = <ThrowOnError extends boolean = false>(
  options: Options<GetProfileData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetProfileResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: "api-key",
        type: "apiKey",
      },
    ],
    url: "/profile",
    ...options,
  });
};

/**
 * zoraSDK_profileBalances query
 */
export const getProfileBalances = <ThrowOnError extends boolean = false>(
  options: Options<GetProfileBalancesData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetProfileBalancesResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: "api-key",
        type: "apiKey",
      },
    ],
    url: "/profileBalances",
    ...options,
  });
};

/**
 * zoraSDK_profileBySocialHandle query
 */
export const getProfileBySocialHandle = <ThrowOnError extends boolean = false>(
  options: Options<GetProfileBySocialHandleData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetProfileBySocialHandleResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: "api-key",
        type: "apiKey",
      },
    ],
    url: "/profileBySocialHandle",
    ...options,
  });
};

/**
 * zoraSDK_profileCoins query
 */
export const getProfileCoins = <ThrowOnError extends boolean = false>(
  options: Options<GetProfileCoinsData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetProfileCoinsResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: "api-key",
        type: "apiKey",
      },
    ],
    url: "/profileCoins",
    ...options,
  });
};

/**
 * zoraSDK_profileSocial query
 */
export const getProfileSocial = <ThrowOnError extends boolean = false>(
  options: Options<GetProfileSocialData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetProfileSocialResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: "api-key",
        type: "apiKey",
      },
    ],
    url: "/profileSocial",
    ...options,
  });
};

/**
 * zoraSDK_tokenInfo query
 */
export const getTokenInfo = <ThrowOnError extends boolean = false>(
  options: Options<GetTokenInfoData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetTokenInfoResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: "api-key",
        type: "apiKey",
      },
    ],
    url: "/tokenInfo",
    ...options,
  });
};

/**
 * zoraSDK_topLiveStreams query
 */
export const getTopLiveStreams = <ThrowOnError extends boolean = false>(
  options?: Options<GetTopLiveStreamsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    GetTopLiveStreamsResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: "api-key",
        type: "apiKey",
      },
    ],
    url: "/topLiveStreams",
    ...options,
  });
};

/**
 * zoraSDK_traderLeaderboard query
 */
export const getTraderLeaderboard = <ThrowOnError extends boolean = false>(
  options?: Options<GetTraderLeaderboardData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    GetTraderLeaderboardResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: "api-key",
        type: "apiKey",
      },
    ],
    url: "/traderLeaderboard",
    ...options,
  });
};

/**
 * zoraSDK_trendCoin query
 */
export const getTrendCoin = <ThrowOnError extends boolean = false>(
  options: Options<GetTrendCoinData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetTrendCoinResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: "api-key",
        type: "apiKey",
      },
    ],
    url: "/trendCoin",
    ...options,
  });
};

/**
 * zoraSDK_trendsByName query
 */
export const getTrendsByName = <ThrowOnError extends boolean = false>(
  options: Options<GetTrendsByNameData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetTrendsByNameResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: "api-key",
        type: "apiKey",
      },
    ],
    url: "/trendsByName",
    ...options,
  });
};

/**
 * zoraSDK_walletTradeActivity query
 */
export const getWalletTradeActivity = <ThrowOnError extends boolean = false>(
  options: Options<GetWalletTradeActivityData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    GetWalletTradeActivityResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        name: "api-key",
        type: "apiKey",
      },
    ],
    url: "/walletTradeActivity",
    ...options,
  });
};

export const postQuote = <ThrowOnError extends boolean = false>(
  options?: Options<PostQuoteData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).post<
    PostQuoteResponse,
    PostQuoteError,
    ThrowOnError
  >({
    security: [
      {
        name: "api-key",
        type: "apiKey",
      },
    ],
    url: "/quote",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

export const postCreateContent = <ThrowOnError extends boolean = false>(
  options?: Options<PostCreateContentData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).post<
    PostCreateContentResponse,
    PostCreateContentError,
    ThrowOnError
  >({
    security: [
      {
        name: "api-key",
        type: "apiKey",
      },
    ],
    url: "/create/content",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};
